module.exports = __webpack_public_path__ + "img/new_player_rt.28ea361e.png";